import { isAfter, isValid, parse } from "date-fns";

export const validateCPF = (cpf) => {
	if (!cpf) return false;
	
	const digits = String(cpf).replace(/\D/g, "");
	if (digits.length !== 11 || /^(\d)\1{10}$/.test(digits)) return false;

	const calcDigit = (length) => {
		let sum = 0;
		for (let i = 0; i < length; i++) {
			sum += parseInt(digits.charAt(i)) * (length + 1 - i);
		}
		const result = 11 - (sum % 11);
		return result > 9 ? 0 : result;
	};

	return parseInt(digits.charAt(9)) === calcDigit(9) && parseInt(digits.charAt(10)) === calcDigit(10);
};

export const validadeBirthDate = (birthDate, today) => {
	const parsedDate = parse(birthDate, "dd/MM/yyyy", new Date());

	if (!isValid(parsedDate)) {
		if (/^\d{2}\/\d{2}\/\d{4}$/.test(birthDate)) {
			return { isValid: false, errorCode: "INVALID_DATE" }; // Data inválida (ex: 12/30/2018)
		} else {
			return { isValid: false, errorCode: "FORMAT_ERROR" }; // Erro de formatação (ex: 12/03/20__)
		}
	}

	if (isAfter(parsedDate, today)) {
		return { isValid: false, errorCode: "FUTURE_DATE" }; // Data no futuro (ex: 12/09/2043)
	}

	return { isValid: true };
};
